import "../Common.css"

type ValResultProps ={
    error:string     // pass in "errors.address" (for example). message will be displayed if it's not null/empty
}

const ValResult = (props:ValResultProps) => {

    const {error} = props;

    return <>
        {   (error) ? <span className="valerror" >{error}</span> : null }
    </>

}

export default ValResult;
